import { MccActionTypes, MccState } from "./types";
import { fetchError, fetchRequest, fetchSuccess } from "./actions";
import { createReducer } from "typesafe-actions";

export const initialState: MccState = {
  loading: false,
  errors: undefined,
  data: []
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>;

export default createReducer<MccState, ActionType>(initialState)
  .handleType(MccActionTypes.FETCH, state => ({
    ...state,
    loading: true,
    data: [],
    errors: undefined
  }))
  .handleType(MccActionTypes.FETCH_SUCCESS, (state, action) => ({
    ...state,
    loading: false,
    data: (action.payload.data ? action.payload.data : []),
    errors: undefined
  }))
  .handleType(MccActionTypes.FETCH_ERROR, (state, action) => ({
    ...state,
    loading: false,
    data: [],
    errors: action.payload
  }));
